import { fabric } from 'fabric';
import pull from 'lodash-es/pull';
import set from 'lodash-es/set';
import uuid from 'uuid';
const DEFAULT_FILL = 'rgba(255,0,0,.5)';

const ownProperties = 'slide direction'.split(' ');
const LudusGuideline = fabric.util.createClass(fabric.Object, {
  type: 'ludusGuideline',
  direction: 'vertical',
  fill: DEFAULT_FILL,

  initialize(options) {
    // if no strokeWidth, rendering issue can occur
    const optionsFixed = {
      ...options,
      canvasId: options.canvasId || uuid.v4(),
      width: options.direction === 'horizontal' ? 4000 : 0,
      height: options.direction === 'vertical' ? 4000 : 0,
      strokeWidth: 0,
      padding: 10, // for dynamic hover that draw  border controls
      originX: 'center',
      originY: 'center',
      hasControls: false,
      hoverCursor:
        options.direction === 'horizontal' ? 'ns-resize' : 'ew-resize',
      moveCursor:
        options.direction === 'horizontal' ? 'ns-resize' : 'ew-resize',
    };

    this.callSuper('initialize', optionsFixed);
    set(this, 'ludus.type', 'guideline');

    this.on('mousedown', this.onMouseDown);
    this.on('mouseup', this.onMouseUp);
    this.on('mousedown:before', this._mouseDownHandlerBefore);
    this.on('added', this._onAdd.bind(this));
    this.on('removed', this._onRemove.bind(this));
    this.selectable = false;
    this.initialized = true;
  },

  _onAdd: function() {
    if (this.canvas && this.canvas.interactive) {
      if (this.canvas.guidelines) {
        this.canvas.guidelines.push(this);
      } else {
        this.canvas.guidelines = [this];
      }
    }
  },

  _onRemove: function() {
    if (this.canvas.guidelines) {
      this.canvas.guidelines = this.canvas.guidelines.filter(
        g => g.canvasId !== this.canvasId,
      );
    }
  },

  getBoundingRect: function() {
    if (this.direction === 'vertical') {
      return { width: 0, height: 10000, x: this.left, y: 0 };
    }
    if (this.direction === 'horizontal') {
      return { width: 10000, height: 0, x: 0, y: this.top };
    }
  },

  drawBorders: function(ctx, styleOverride) {
    ctx.save();
    ctx.strokeStyle = 'cyan';
    ctx.beginPath();
    if (this.direction === 'vertical') {
      ctx.moveTo(0, -10000);
      ctx.lineTo(0, 10000);
    } else {
      ctx.moveTo(-10000, 0);
      ctx.lineTo(10000, 0);
    }
    ctx.stroke();

    ctx.restore();
    return this;
  },

  _set(key, value) {
    if (!this.initialized) {
      this.callSuper('_set', key, value);
      return this;
    }

    if (key === 'top' && this.direction === 'vertical') {
      this.callSuper('_set', key, 0);
      this.setCoords();
      return this;
    }
    if (key === 'left' && this.direction === 'horizontal') {
      this.callSuper('_set', key, 0);
      this.setCoords();
      return this;
    }
    this.callSuper('_set', key, value);
  },

  _mouseDownHandlerBefore(e) {
    if (!e.e.shiftKey) {
      this.selectable = true;
    } else {
      this.selectable = false;
    }
  },

  onMouseUp(e) {
    const absolutePosition = this.canvas && this.canvas.getPointer(e.e, true);
    if (
      (absolutePosition &&
        absolutePosition.x < 20 &&
        this.direction === 'vertical') ||
      (absolutePosition &&
        absolutePosition.y < 20 &&
        this.direction === 'horizontal')
    ) {
      this.canvas.fire('guideline:removedByDrag', { target: this });
      if (this.canvas) {
        this.canvas.remove(this);
      }
    }

    this.selectable = false;
  },

  // Render is done on afterRenderBackground by guidelines.jsx
  _render() {},
  //
  manualRender(ctx, zoom) {
    ctx.strokeStyle = this.fill || DEFAULT_FILL;
    ctx.beginPath();

    if (this.direction === 'vertical') {
      ctx.moveTo((this.left - this.canvas.vptCoords.tl.x) * zoom, 0);
      ctx.lineTo((this.left - this.canvas.vptCoords.tl.x) * zoom, 2000);
    } else {
      ctx.moveTo(0, (this.top - this.canvas.vptCoords.tl.y) * zoom);
      ctx.lineTo(4000, (this.top - this.canvas.vptCoords.tl.y) * zoom);
    }
    ctx.stroke();
  },

  toObject(propertiesToInclude) {
    const _propertiesToInclude = pull(
      propertiesToInclude,
      'perPixelTargetFind',
      'lockUniScaling',
      'lockMovementX',
      'lockMovementY',
      'direction',
    );
    const properties = _propertiesToInclude || [];
    return this.callSuper('toObject', properties.concat(ownProperties));
  },
});

LudusGuideline.fromObject = function fromObject(object, callback) {
  const options = fabric.util.object.clone(object, true);

  if (callback) callback(new LudusGuideline(options));
};

export default LudusGuideline;
